<template>
  <div class="cart-page">

    <!-- SOL: TABLO TİPİ SEPET -->
    <div class="cart-left">

      <!-- TABLO BAŞLIK (SADECE PC) -->
      <div class="cart-header-row" :class="{ 'with-iskonto': hasIskonto }">
        <div class="cell cell-img-head"></div>
        <div class="cell cell-urun">Ürün</div>
        <div class="cell"></div>
        <div class="cell cell-miktar">Miktar</div>

        <div class="cell cell-kdv">Kdv</div>
        <div class="cell cell-net">Net Fiyat</div>
        <div v-if="hasIskonto" class="cell cell-iskonto">İskonto</div>
        <div class="cell cell-tutar">Tutar</div>
        <div class="cell cell-sil">Sil</div>

      </div>

      <div v-if="!items.length" class="cart-empty">
        Sepetinizde ürün bulunmamaktadır.
      </div>
      <div v-for="item in displayItems" :key="item.id" class="cart-row" :class="{ 'with-iskonto': hasIskonto }">
        <!-- Resim -->
        <div class="cell cell-img">
          <div class="img-wrapper">
            <img  class="cart-item-img" :src="item.url && item.url !== ''  ? item.url  : ('/upload/' + item.foto + '.jpg')"
            @error=" $event.target.onerror = null; $event.target.src = '/src/static/resimyok.jpg'; " >
          </div>
        </div>
        <div class="cell cell-urun desktop-only" style="margin-left:10px; display:block !important">
          <span style="display: block;"> {{ item.marka+ ' ' +item.isim }} </span>
          <span style="display: block; font-size: 13px; font-weight: 600;"> {{ item.renk || ""+ ' '+item.beden || ""+ ' '+paketbul(item.paket) }} </span>

          
          <small style="display: block;">{{ item.note }}</small>


        </div>
        <!-- PC KOLONLARI -->
        <div class="cell cell-kod-marka desktop-only">
          <span class="code">{{ item.birim }}</span>
        </div>



        <div class="cell cell-miktar desktop-only">
          <input
            type="number"
            min="1"
            class="qty-input"
            v-model.number="item.adet"
            @input="onQtyChange(item)"
            @change="onQtyChange(item)"
          >
        </div>

        <div class="cell cell-kdv desktop-only">
          {{ formatTL(lineKdv(item)) }}
        </div>

        <div class="cell cell-net desktop-only">
          {{ formatTL(lineNetBirimFiyat(item)) }}
        </div>

        <div v-if="hasIskonto" class="cell cell-iskonto desktop-only">
          {{ formatTL(lineIskontoTutar(item)) }}
        </div>

        <div class="cell cell-tutar desktop-only">
          {{ formatTL(lineTutarFinal(item)) }}
        </div>

        <!-- Sil (PC + Mobil) -->
        <div class="cell cell-sil">
          <button
            class="remove-btn"
            v-if="!isKargoItem(item)"
            @click="removeItem(item)"
            :title="item.isim + ' ürününü sepetten çıkar'"
          >
            🗑
          </button>
        </div>

        <!-- 📱 MOBİL / DİKEY TABLET: Resmin sağındaki blok -->
        <div class="cell cell-main-mobile mobile-only">
          <!-- 1. satır: Ürün -->
          <div class="m-row">
            <span class="m-label">Ürün:</span>
            <span class="m-name">{{ item.marka+' '+item.isim }}</span>
          </div>

          <!-- 2. satır: Kod + Marka -->
          <div class="m-row">
            <span class="m-label">Kod:</span>
            <span class="m-code">{{ item.kod }}</span>

            <span class="m-space"></span>

            <span class="m-label">Birim :</span>
            <span class="m-marka">{{ item.birim }}</span>

            <span class="m-marka">  {{ item.note }}</span>
          </div>
          <div class="m-row">
            <span class="m-label">Fiyat :</span>
            <span class="m-value">{{ formatTL(lineNetBirimFiyat(item)) }}</span>

            <span class="m-label">Kdv:</span>
            <span class="m-value">{{ formatTL(lineKdv(item)) }}</span>

            <span class="m-label">Tutar :</span>
            <span class="m-value">{{ formatTL(lineTutarFinal(item)) }}</span>
            
          </div>
          <!-- 3. satır: Miktar + Net Fiyat + Kdv + Tutar -->
          <div class="m-row m-row-bottom">
                        <span class="m-label">Miktar :</span>

            <input
              type="number"
              min="1"
              class="qty-input-mobile"
              v-model.number="item.adet"
              @input="onQtyChange(item)"
              @change="onQtyChange(item)"
            >
          <button
            class="remove-btn"
            style="margin-left : 50px; font-size:21px"
            v-if="!isKargoItem(item)"
            @click="removeItem(item)"
            :title="item.isim + ' ürününü sepetten çıkar'"
          >
            🗑
          </button>
          

          </div>
        </div>
      </div>
    </div>

    <!-- SAĞ: SİPARİŞ ÖZETİ (PC / yatay tablet) -->
    <div class="cart-right">
      <div class="summary-card">
        <h3>Sepet Özeti</h3>

        <div class="summary-row">
          <span>TOPLAM</span>
          <span>{{ formatTL(toplamBrut) }}</span>
        </div>
        <div class="summary-row">
          <span>İSKONTO</span>
          <span class="text-danger">- {{ formatTL(toplamIskonto) }}</span>
        </div>
        <div class="summary-row">
          <span>ARA TUTAR</span>
          <span>{{ formatTL(toplamAraTutar) }}</span>
        </div>
        <div class="summary-row">
          <span>KDV</span>
          <span>{{ formatTL(toplamKdv) }}</span>
        </div>

        <div class="summary-row">
          <span>Taşıma Bedeli</span>
          <span>{{ formatTL(kargoTutar) }}</span>
        </div>

        <div class="summary-divider"></div>

        <div class="summary-row total">
          <span>TUTAR</span>
          <span>{{ formatTL(genelTutar) }}</span>
        </div>

        <div class="summary-row">
          <span>Cari Bakiye</span>
          <span>{{ formatTL($store.aktifCari.bakiye) }}</span>
        </div>
        <div class="summary-row" style="margin-bottom: 15px;">
          <span>Cari Limiti</span>
          <span>{{ formatTL(cariLimiti) }}</span>
        </div>
        <button type="button" class="kayit-btn" @click="guncelle">
          Değişiklikleri Kaydet
        </button>      
        <button type="button" class="pay-btn" @click="onPay">
          Siparişi Tamamla
        </button>   
      </div>
    </div>

    <!-- 📱 MOBİL FOOTER: GENEL TOPLAM + BUTON -->
    <div class="mobile-footer-total">
      <div class="footer-total-text">
        <span class="label">Ara Toplam</span>
        <span class="value">{{ formatTL(toplamBrut) }}</span>
      </div>
      <div class="footer-total-text">
        <span class="label">İskonto</span>
        <span class="value">{{ formatTL(toplamIskonto) }}</span>
      </div>
      <div class="footer-total-text">
        <span class="label">KDV</span>
        <span class="value">{{ formatTL(toplamKdv) }}</span>
      </div>
      <div class="footer-total-text">
        <span class="label">Genel Toplam</span>
        <span class="value">{{ formatTL(genelTutar) }}</span>
      </div>                  
      <button type="button" class="footer-pay-btn" @click="onPay">
        Ödeme Yap
      </button>
    </div>

  </div>
</template>


<script>
import db from '../../db';

import fiyatHelper from '../../services/fiyat/yapas.js'  // yeni dosya

export default {
  name: 'Sepet',
  data() {
    return {
      hesap:this.$request.ayar(),
      items: [],
      siparisNotu: '',
      cariLimiti: 0,
      saving: false,
      buildSeq: 0,
      kargoSyncing: false,
      kargo:{
        "20":  { fiyat:30000,kod:'602' }
      }
    };
  },
  async created() {
    this.$store.setLoading([false,''])
    this.buildCartItems()
  },
  watch: {
    '$store.aktifCari'(cari) {
      if (cari && Array.isArray(cari.basket)) {
        this.buildCartItems();
      }
    }
  },
  computed: {
    kargoRule() {
      const fid = this.hesap && this.hesap.fid != null ? String(this.hesap.fid) : "";
      if (!fid) return null;
      const rule = this.kargo && this.kargo[fid] ? this.kargo[fid] : null;
      if (!rule) return null;
      const fiyat = Number(rule.fiyat || 0);
      const kod = String(rule.kod || "").trim();
      if (!kod || !fiyat) return null;
      return { fiyat, kod };
    },
    kargoLine() {
      const rule = this.kargoRule;
      if (!rule) return null;
      return (this.items || []).find(it => String(it.kod || "").trim() === rule.kod) || null;
    },
    kargoTutar() {
      if (!this.kargoLine) return 0;
      return this.lineTutarFinal(this.kargoLine);
    },
    displayItems() {
      const rule = this.kargoRule;
      if (!rule) return this.items || [];
      const kargoKod = String(rule.kod || "").trim();
      return (this.items || []).filter(it => String(it && it.kod ? it.kod : "").trim() !== kargoKod);
    },
    hasIskonto() {
      const raw = this.$store && this.$store.aktifCari ? this.$store.aktifCari.iskontokod : '';
      const str = (raw === null || raw === undefined) ? '' : String(raw).trim();
      if (!str || str === '0') return false;
      const parts = str.split('+').map(p => Number(p) || 0);
      return parts.some(v => v > 0);
    },
    // Satır bazlı hesaplar için yardımcı – global toplamlarda tekrar kullanıyoruz
    toplamBrut() {
      // TOPLAM (brüt) = birimFiyat * adet
      return this.items.reduce((sum, item) => sum + this.lineBrutTutar(item), 0);
    },
    toplamIskonto() {
      return this.items.reduce((sum, item) => sum + this.lineIskontoTutar(item), 0);
    },
    toplamAraTutar() {
      return this.items.reduce((sum, item) => sum + this.lineAraTutar(item), 0);
    },
    toplamKdv() {
      return this.items.reduce((sum, item) => sum + this.lineKdv(item), 0);
    },
    genelTutar() {
      // TUTAR = Ara Tutar + KDV
      return this.toplamAraTutar + this.toplamKdv;
    }
  },
  methods: {

 async buildCartItems() {
   const seq = ++this.buildSeq;
   const cari = this.$store.aktifCari;
   const rawBasket = cari && cari.basket;
   this.items = [];
   if (!rawBasket || !Array.isArray(rawBasket) || rawBasket.length === 0) {
     return;
   }

  this.cartLoading = true;

  try {
    // Aynı guid birden fazla kez gelirse UI'da çiftlenmesin: tekilleştir.
    const basketMap = new Map();
    for (const b of rawBasket) {
      if (!b || b.guid == null) continue;
      const key = String(b.guid);
      const prev = basketMap.get(key);
      if (!prev) {
        basketMap.set(key, { ...b });
      } else {
        // adetleri birleştir (en güvenlisi toplam)
        const a1 = Number(prev.adet || 0) || 0;
        const a2 = Number(b.adet || 0) || 0;
        basketMap.set(key, { ...prev, adet: a1 + a2, note: (b.note != null ? b.note : prev.note) });
      }
    }
    const basket = Array.from(basketMap.values());

    const ids = basket.map(b => b.guid).filter(Boolean);
    if (!ids.length) {
      this.items = [];
      return;
    }

    // stocks DB eşleşmesi
    let stocks = [];
    try {
      stocks = await db.stocks.where('id').anyOf(ids).toArray();
    } catch (e) {
      stocks = await db.stocks.toCollection()
        .filter(s => ids.includes(s.id))
        .toArray();
    }

    const map = {};
    stocks.forEach(s => { map[String(s.id)] = s; });


    // Aynı stok birden fazla guid ile sepete düşmüşse (aynı kod), kod bazında da tekilleştir.
    const basketByKod = new Map();
    for (const row of basket) {
      const guidKey = String(row && row.guid != null ? row.guid : "");
      if (!guidKey) continue;
      const local = map[guidKey];
      if (!local) continue;
      const kodKey = String(local.kod || "").trim();
      if (!kodKey) {
        basketByKod.set("guid:" + guidKey, row);
        continue;
      }
      const prev = basketByKod.get(kodKey);
      if (!prev) basketByKod.set(kodKey, row);
      else {
        const a1 = Number(prev.adet || 0) || 0;
        const a2 = Number(row.adet || 0) || 0;
        basketByKod.set(kodKey, { ...prev, adet: a1 + a2, note: (row.note != null ? row.note : prev.note) });
      }
    }

    const nextItems = [];
    for (const row of Array.from(basketByKod.values())) {
      const local = map[String(row.guid)];
      if (!local) continue;

      // Extra değerler
      const extra = {
        fiyat: local.fiyat,
        kdv: local.kdv
      };
      // 🔥 fiyat hesaplama cari.iskontokod
      const fiyatDetay = await fiyatHelper.getFiyat(
        extra,
        this.$helper,
        this.hesap.kdvli,
       cari.iskontokod ,0,local.doviz || 0
      );

      // net fiyat (iskontolu)
      const netFiyat = typeof fiyatDetay.iskontolu === 'number'
        ? fiyatDetay.iskontolu
        : fiyatDetay.liste;

      const adet = Number(row.adet) || 0;
      const toplamTutar = netFiyat * adet;

      nextItems.push({
        id: row.guid,
        adet,
        note:row.note,
        isim: local.isim,
        marka:local.marka,
        kod: local.kod,
        foto: local.ambalaj || null,
        kdv:local.kdv,
        birim:local.birim,
        url : local.url  || '',

        fiyat1: netFiyat, // bunu silicez
        fiyat : fiyatDetay,
        renk: local.renk || '',
        beden:local.beden,
        paket: local.paket,
      });
    }

    if (seq !== this.buildSeq) return;
    this.items = nextItems;

    //this.items = result;
  } finally {
    this.cartLoading = false;
  }

  await this.ensureKargo();
},

async ensureKargo() {
  const rule = this.kargoRule;
  if (!rule) return;
  if (this.kargoSyncing) return;

  const kargoKod = rule.kod;

  const baseTotal = (this.items || [])
    .filter(it => String(it.kod || "").trim() !== kargoKod)
    .reduce((sum, it) => sum + this.lineTutarFinal(it), 0);

  const shouldHaveKargo = baseTotal < Number(rule.fiyat || 0);
  const hasKargo = !!(this.items || []).find(it => String(it.kod || "").trim() === kargoKod);

  if (shouldHaveKargo && !hasKargo) {
    this.kargoSyncing = true;
    try {
      const stok = await db.stocks.where("kod").equals(String(kargoKod)).first();
      if (!stok || stok.id == null) return;

      const cari = this.$store.aktifCari;
      if (!cari || !cari.kod || !cari.guid) return;

      const obje = { giden: this.$helper.point(cari.kod, [], [], [], stok.id, '', 1, 0, 0, 0, 'isim', 'asc', 1), adet: 1, durum: 1, note: "" };
      const res = await this.$request.post('basket/update', obje);
      if (!res || res.status == 300 || res.status == 503) return;

      const yeniBasket = Array.isArray(cari.basket) ? cari.basket.slice() : [];
      if (!yeniBasket.find(x => x && x.guid === stok.id)) {
        yeniBasket.push({ guid: stok.id, adet: 1, updateAt: new Date().toISOString() });
        await db.caris.update(cari.guid, { basket: yeniBasket });
        this.$store.aktifCari.basket = yeniBasket;
      }

      await this.buildCartItems();
    } finally {
      this.kargoSyncing = false;
    }
    return;
  }

  if (!shouldHaveKargo && hasKargo) {
    this.kargoSyncing = true;
    try {
      const cari = this.$store.aktifCari;
      if (!cari || !cari.kod || !cari.guid) return;

      const kargoItem = (this.items || []).find(it => String(it.kod || "").trim() === kargoKod);
      if (!kargoItem) return;

      await this.$request.post("basket/delete", { cKod: cari.kod, guid: kargoItem.id });

      const yeniBasket = Array.isArray(cari.basket) ? cari.basket.filter(x => x && x.guid !== kargoItem.id) : [];
      await db.caris.update(cari.guid, { basket: yeniBasket });
      this.$store.aktifCari.basket = yeniBasket;

      await this.buildCartItems();
    } finally {
      this.kargoSyncing = false;
    }
  }
},

isKargoItem(item) {
  const rule = this.kargoRule;
  if (!rule) return false;
  return String(item && item.kod ? item.kod : "").trim() === String(rule.kod || "").trim();
},

   // ---- SATIR HESAPLARI ----
    lineBrutTutar(item) {
      const adet = Number(item && item.adet ? item.adet : 0) || 0;
      const birimListe = item && item.fiyat && typeof item.fiyat.liste === 'number'
        ? item.fiyat.liste
        : (Number(item && item.fiyat1 ? item.fiyat1 : 0) || 0);
      return birimListe * adet;
    },
    lineIskontoTutar(item) {
      const adet = Number(item && item.adet ? item.adet : 0) || 0;
      if (item && item.fiyat && typeof item.fiyat.liste === 'number' && typeof item.fiyat.iskontolu === 'number') {
        const diff = item.fiyat.liste - item.fiyat.iskontolu;
        return diff > 0 ? diff * adet : 0;
      }
      const brut = this.lineBrutTutar(item);
      return (brut * (Number(item && item.iskontoOran ? item.iskontoOran : 0) || 0)) / 100;
    },
    lineAraTutar(item) {
      // iskonto sonrası satır tutarı
      return this.lineBrutTutar(item) - this.lineIskontoTutar(item);
    },
    lineKdv(item) {
      const ara = this.lineAraTutar(item);
      return (ara * (item.kdv || 0)) / 100;
    },
    lineTutarFinal(item) {
      // net satır tutar = ara + kdv
      return this.lineAraTutar(item) + this.lineKdv(item);
    },
    lineNetBirimFiyat(item) {
      if (item && item.fiyat && typeof item.fiyat.iskontolu === 'number') {
        return item.fiyat.iskontolu;
      }
      const adet = Number(item && item.adet ? item.adet : 1) || 1;
      const ara = this.lineAraTutar(item);
      return ara / adet;
    },

    // ---- GENEL ----
    formatTL(val) {
      if (isNaN(val)) return '0,00 TL';
      return new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY',
        minimumFractionDigits: 2
      }).format(val);
    },
onQtyChange: function (item) {
  // 1) min 1 zorunluluğu (senin kuralın)
  var qty = Number(item && item.adet ? item.adet : 0);

  if (!qty || qty < 1) qty = 1;

  // number input bazen float bırakır; istersen tam sayıya indir
  qty = Math.floor(qty);

  // 2) Paket S değilse: sadece satırı düzelt ve çık
  if (!item || item.paket !== 'S') {
    item.adet = qty;
    return;
  }

  // 3) Paket S ise: aynı ambalaj + aynı beden olan tüm satırlara uygula
  var amb = String(item.ambalaj || '');
  var beden = String(item.beden || '');

  // güvenlik: items yoksa sadece kendine uygula
  var rows = (this && this.items && this.items.length) ? this.items : [];

  for (var i = 0; i < rows.length; i++) {
    var r = rows[i];
    if (!r) continue;

    if (String(r.ambalaj || '') === amb &&
        String(r.beden || '') === beden) {
      r.adet = qty;
    }
  }

  // 4) (opsiyonel) burada store commit / API update
  // this.$store.commit('...', this.items)
},
   async  removeItem(item) {
      if (this.isKargoItem(item)) {
        alert("Taşıma bedeli sepetten silinemez.");
        return;
      }

      this.$swal({
        title: "Eminmisiniz ?",
        text: "Bu işlem geri alınamaz",
        icon: "info",
        showCancelButton: true,
        cancelButtonText: "Hayır",
        confirmButtonText: "Evet",
        //showCloseButton: true,
        //showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          const cari = this.$store.aktifCari;
          this.$store.setLoading([true,'Bekleyiniz'])
          this.$request.post("basket/delete", { cKod: cari.kod, guid:item.id, }).then(res=>{
        if (res.status!= 300) {
          const yeniBasket = cari.basket.filter( items => items.guid !== item.id )

          db.caris.update(cari.guid, { basket: yeniBasket });
          this.items = this.items.filter(x => x.id !== item.id);
          this.$store.setLoading([false,'Bekleyiniz'])

        }
        else {
            this.$store.setLoading([false,'Bekleyiniz'])
            this.$router.push("/oturum")
         
        }
      })

        }
      });

      // burada da backend / store senkronizasyonu
    },
    async onPay() {
    this.$store.setLoading([true,'Bekleyiniz'])

      // 1) Aktif cariyi IndexedDB'den çek
      var aktifCari = this.$store.aktifCari

      if (!aktifCari) {
        console.warn('Aktif cari bulunamadı');
        return;
      } 
      // 2) Popup içindeki satırlardan, gönderilecekleri sıraya göre hazırla
      var rowsToSend = this.items
        .map(function (r, index) {
          return {
            sira: index + 1,            // UI'daki görüntü sırası
            guid: r.id,
            adet: Number(r.adet || 0),
            kod: r.kod,
            note:r.note
            //ambalaj: r.ambalaj
          };
        })
        .filter(function (r) {
          return r.adet > 0;            // adet 0 olanları göndermiyoruz
        }); 
      // 3) Mevcut basket'in kopyası (diğer ürünler korunacak)
      var newBasket = Array.isArray(aktifCari.basket)
        ? aktifCari.basket.slice()
        : [];

      // 4) Her satırı endpoint'e TEK TEK sırayla gönder
      for (var i = 0; i < rowsToSend.length; i++) {
        var row = rowsToSend[i];

        try {
          let obje = { giden: this.$helper.point(aktifCari.kod, [], [], [],row.guid, '', 1, 0, 0, 0, 'isim', 'asc', 1),adet: row.adet, durum: 1,note:row.note }
          var res = await this.$request.post('basket/update', obje);


          // API cevabını kendi yapına göre uyarlayacaksın
          // Örnek varsayım:
          // res.data = { success: true, item: { guid, adet, sira } }
          //var data = res && res.data ? res.data : null;

          if (res.status !=200) {
            // backend "başarısız" dediyse local basket'i değiştirme
            continue; //döngünün geri kalan satırlarını çalıştırmaz
          }


          var updatedGuid = row.guid;
          var updatedAdet = row.adet;
          var updatedDate = new Date().toISOString();

          // 5) newBasket içinde bu guid var mı?
          var idx = -1;
          for (var j = 0; j < newBasket.length; j++) {
            if (newBasket[j].guid === updatedGuid) {
              idx = j;
              break;
            }
          }

          if (idx === -1) {
            // Sepette yoksa yeni ürün olarak ekle
            newBasket.push({
              guid: updatedGuid,
              adet: updatedAdet,
              updateAt: updatedDate,

            });
          } else {
            // Varsa adet ve sırayı güncelle (diğer alanlara dokunma)
            var mevcut = newBasket[idx];
              newBasket[idx] = Object.assign({}, mevcut, {
              adet: updatedAdet,
              updateAt: updatedDate,


            });
          }
        } catch (e) {
          console.error('basketUpdate hata:', e);
          // İstersen burada kullanıcıya uyarı gösterebilirsin
          // this.$helper.toast('Sepete eklenirken hata oluştu');
        }
      }

      // 6) Endpoint'ten başarılı geçen satırlara göre DB'de cari basket'i güncelle
      await db.caris
        .where('guid')
        .equals(aktifCari.guid)
        .modify({ basket: newBasket }); 
          setTimeout(() => {
            this.$store.setLoading([false,'Bekleyiniz'])
            this.$router.push("/siparis/add")
          }, 1500);

    },   

    async guncelle() {
      if (this.saving) return;
      this.saving = true;
      this.$store.setLoading([true,'Bekleyiniz'])

      // 1) Aktif cariyi IndexedDB'den çek
      var aktifCari = this.$store.aktifCari

      if (!aktifCari) {
        console.warn('Aktif cari bulunamadı');
        return;
      } 
      // 2) Popup içindeki satırlardan, gönderilecekleri sıraya göre hazırla
      // 2) Gönderilecek satırlar (guid bazında tekilleştir)
      var rowsToSendRaw = this.items
        .map(function (r, index) {
          return {
            sira: index + 1,
            guid: r.id,
            adet: Number(r.adet || 0),
            kod: r.kod,
            note: r.note
          };
        })
        .filter(function (r) { return r.adet > 0 && r.guid != null; });

      var rowMap = {};
      for (var x = 0; x < rowsToSendRaw.length; x++) {
        var rr = rowsToSendRaw[x];
        var key = String(rr.guid);
        if (!rowMap[key]) rowMap[key] = Object.assign({}, rr, { guid: rr.guid });
        else {
          rowMap[key].adet = (Number(rowMap[key].adet || 0) || 0) + (Number(rr.adet || 0) || 0);
          if (rr.note != null) rowMap[key].note = rr.note;
        }
      }
      var rowsToSend = Object.keys(rowMap).map(function (k) { return rowMap[k]; });

      // 3) Local basket'i sadece tekil satırlardan yeniden oluştur (çiftlenmeyi engelle)
      var nowIso = new Date().toISOString();
      var newBasket = rowsToSend.map(function (r) {
        return {
          guid: r.guid,
          adet: Number(r.adet || 0) || 0,
          note: r.note,
          updateAt: nowIso
        };
      });

      // 4) Her satırı endpoint'e TEK TEK sırayla gönder
      for (var i = 0; i < rowsToSend.length; i++) {
        var row = rowsToSend[i];

        try {
          let obje = { giden: this.$helper.point(aktifCari.kod, [], [], [],row.guid, '', 1, 0, 0, 0, 'isim', 'asc', 1),adet: row.adet, durum: 1,note:row.note }
          var res = await this.$request.post('basket/update', obje);


          // API cevabını kendi yapına göre uyarlayacaksın
          // Örnek varsayım:
          // res.data = { success: true, item: { guid, adet, sira } }
          //var data = res && res.data ? res.data : null;

          if (res.status !=200) {
            // backend "başarısız" dediyse local basket'i değiştirme
            continue; //döngünün geri kalan satırlarını çalıştırmaz
          }


          // newBasket zaten tekil; burada tekrar birleştirme yapmıyoruz.
        } catch (e) {
          console.error('basketUpdate hata:', e);
          // İstersen burada kullanıcıya uyarı gösterebilirsin
          // this.$helper.toast('Sepete eklenirken hata oluştu');
        }
      }

      // 6) Endpoint'ten başarılı geçen satırlara göre DB'de cari basket'i güncelle
      await db.caris
        .where('guid')
        .equals(aktifCari.guid)
        .modify({ basket: newBasket }); 
      if (this.$store && this.$store.aktifCari && this.$store.aktifCari.guid === aktifCari.guid) {
        this.$store.aktifCari.basket = newBasket;
      }

      // UI tarafını da tekilleştirilmiş basket'e göre tazele
      try {
        // buildCartItems zaten store watcher ile de tetikleniyor; burada ekstra çağırmayalım (çakışma/çift render yapıyor).
      } finally {
        this.$store.setLoading([false,'Bekleyiniz'])
        this.saving = false;
      }


    },
    paketbul(durum) {
      switch (durum) {
        case "":
          return "Tekli";
          break;
        case "S":
          return "Seri";
          break;
        case "DZ":
          return "Düzine";
          break;
        case "P1":
          return "Tekli";
          break;
        case "P2":
          return "2 li";
          break;
        case "P3":
          return "3 lü";
          break;
        case "P4":
          return "4 lü";
          break;
        case "P5":
          return "5 li";
          break;
        case "P6":
          return "6 lı";
          break;
        default:
        return ""
      }
    },    
  }
};
</script>

<style scoped>
/* SAYFA LAYOUT */
.cart-page {
  display: grid;
  grid-template-columns: 3.5fr 1.3fr;
  gap: 24px;
  max-width:100%;
  margin: 0 auto;
  padding: 16px;
}

@media (max-width: 1200px) {
  .cart-page {
    grid-template-columns: 3fr 1.6fr;
  }
} 

/* BAŞLIK (PC) */
.cart-header-row {
  display: grid;
  grid-template-columns: 90px  160px 1fr 90px 90px 110px 110px 60px;
  padding: 10px 12px;
  background: #f5f7f9;
  border-radius: 8px 8px 0 0;
  font-size: 13px;
  font-weight: 600;
  color: #555;
} 
.cart-header-row.with-iskonto {
  grid-template-columns: 90px  160px 1fr 90px 90px 110px 110px 110px 60px;
}
/* SATIR (PC default) */
.cart-row {
  display: grid;
  grid-template-columns: 90px  1fr 60px 120px 90px 110px 110px 60px;
  align-items: center;
  padding: 10px 12px;
  background: #fff;
  border-bottom: 1px solid #eceff1;
  min-height: 80px;
  max-height: 80px;
  overflow: hidden;
  position: relative;
}
.cart-row.with-iskonto {
  grid-template-columns: 90px  1fr 60px 120px 90px 110px 110px 110px 60px;
}

.cart-row:last-child {
  border-radius: 0 0 8px 8px;
}

.cell {
  display: flex;
  align-items: center;
}

/* Resim */
.img-wrapper {
  width: 80px;
  height: 80px;
  background: #f0f2f4;
  border-radius: 5%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right:5px
}

.img-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* PC / Mobil görünürlük */
.desktop-only {
  display: flex;
}

.mobile-only {
  display: none;
}



/* PC kolon içerikleri */
.cell-kod,
.cell-marka,
.cell-urun,
.cell-miktar,
.cell-kdv,
.cell-net,
.cell-tutar {
  font-size: 15px;
}
.cell-kod-marka {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.cell-kod-marka .code {
  font-size: 13px;
  font-weight: 600;
  color: #333; 
}

.cell-kod-marka .brand {
  font-size: 11px;
  color: #777;
  margin-top: 2px;
}
.qty-input {
  width: 60px;
  padding: 3px 4px;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 13px;
  text-align: center;
}

/* SATIR – MOBİL + DİKEY TABLET */
@media (max-width: 992px) {
  .cart-row {
    grid-template-columns: 80px 1fr;
    padding: 6px 2px;
    min-height: 120px;
    max-height: 120px; /* resim yüksekliğini geçmesin */
  }

  .cell-main-mobile {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    overflow: hidden;
  }

  /* Üç satırın ortak stili */
  .m-row {
    font-size: 12px;
    line-height: 1.5;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .m-row + .m-row {
    margin-top: 5px; /* satırlar arası çok az boşluk */
  }

  /* 3. satır: Miktar + Net Fiyat + Kdv + Tutar */
  .m-row-bottom {
    display: flex;
    align-items: center;
    gap: 3px;
    margin-top: 3px;
  }

  .m-label {
    font-size: 13px;
    color: #999;
    margin-right: 2px;
  }

  .m-code {
    font-size: 11px;
    font-weight: 500;
  }

  .m-arrow {
    margin: 0 3px;
  }

  .m-name {
    font-size: 13px;
    font-weight: 600;
  }

  .m-marka {
    font-size: 12px;
  }

  .m-space {
    display: inline-block;
    width: 10px; /* Kod ile Marka arasında boşluk */
  }

  .m-value {
    font-size: 12px;
    font-weight: 500;
  }

  .qty-input-mobile {
    width: 60px;
    min-height:30px;
    padding: 1px 2px;
    border-radius: 4px;
    border: 1px solid #ccc;
    font-size: 14px;
    font-weight:500;
    text-align: center;
  }

  /* Çöp ikonu sağ üst köşe */
  .cell-sil {
    grid-column: 3 / 4;
    grid-row: 1 / 2;
    justify-content: flex-end;
    align-items: flex-start;
  }
  .cell-main-mobile {
    text-align: left !important;
    align-items: flex-start !important;
  }

  .m-row {
    text-align: left !important;
    justify-content: flex-start !important;
  }

  .m-row-bottom {
    justify-content: flex-start !important;
  }
    .desktop-only {
    display: none !important;
  }
  .mobile-only {
    display: block;
  }
  .cart-header-row {
    display: none;
  }  
  .cart-page {
    grid-template-columns: 1fr;
    padding-bottom: 70px; /* mobil footer için boşluk */
  }
  .cart-right {
    order: 2;
  }
.img-wrapper {
  width: 100px !important;
  height: 100px;
  background: #f0f2f4;
  border-radius: 5%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right:5px
}
 .cell-sil {
    display: none !important;
  }
  .summary-card .summary-row,
  .summary-card .summary-divider,
  .summary-card .pay-btn {
    display: none !important;
  }

  /* Sadece Sipariş Notu bölümü kalsın */
  .summary-card {
    position: static;       /* sticky olmasına gerek yok */
    margin-top: 12px;
    padding: 10px 12px;
  }

  .summary-card h3 {
    display: none;          /* "Sepet Özeti" başlığını da istersen gizle */
  }

  .summary-note {
    margin-top: 0;
  }  
}

/* Sil butonu */
.cell-sil {
  justify-content: center;
}

.remove-btn {
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 18px;
  color: #0d6efd;
}

.remove-btn:hover {
  color: #c0392b;
}

/* BOŞ SEPET */
.cart-empty {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  margin-top: 8px;
  color: #777;
}

/* SAĞ ÖZET PANEL */
.summary-card {
  background: #fff;
  border-radius: 8px;
  padding: 16px 18px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
  position: sticky;
  top: 16px;
}

.summary-card h3 {
  margin: 0 0 12px;
  font-size: 18px;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  border-bottom: 1px solid #f0f2f4;
  font-size: 14px;
}

.summary-row:last-of-type {
  border-bottom: none;
}

.summary-row.total {
  font-weight: 700;
}

.summary-divider {
  height: 1px;
  background: #eceff1;
  margin: 8px 0;
}

.summary-note {
  margin-top: 12px;
}

.summary-note label {
  font-size: 13px;
  display: block;
  margin-bottom: 4px;
}

.summary-note textarea {
  width: 100%;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 13px;
  padding: 6px;
  resize: vertical;
}

.pay-btn {
  width: 100%;
  margin-top: 10px;
  border: none;
  border-radius: 4px;
  padding: 10px;
  font-size: 14px;
  font-weight: 600;
  background: #16a34a;
  color: #fff;
  cursor: pointer;
} 
.kayit-btn {
  width: 100%;
  margin-top: 10px;
  border: none;
  border-radius: 4px;
  padding: 10px;
  font-size: 14px;
  font-weight: 600;
  background: #ea580c;
  color: #fff;
  cursor: pointer;
} 
/* MOBİL FOOTER TOPLAM */
.mobile-footer-total {
  display: none;
}
/* fixed footer */
@media (max-width: 992px) { 
  .cell-urun {display:none}
  .summary-card {
    position: static;
    margin-top: 12px;
  }  
  .mobile-footer-total {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: 56px;
    background: #fff;
    border-top: 1px solid #e0e4e8;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    z-index: 999;
  }
}

.footer-total-text .label {
  font-size: 11px;
  color: #777;
  display: block;
}

.footer-total-text .value {
  font-size: 14px;
  font-weight: 700;
}

.footer-pay-btn {
  border: none;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 600;
  background: #0d6efd;
  color: #fff;
  cursor: pointer;
}

/* Yardımcı */
.text-danger {
  color: #c0392b;
}
.btn-orange {
    background: #f59e0b !important;
}

.btn-blue {
    background: #1d4ed8 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/cari/sepet.vue